// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9ed255f8","455":"4f612a50"}[chunkId] + ".chunk.js";
};